import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Table themes (docs/proposals/themable-surfaces.md): one per-device choice, `default` is the stock
 * look byte for byte. The available ids are the build's registered themes; a theme whose manifest
 * fails to load falls back to default at render time, not here.
 */
export const TABLE_THEMES = ['default', 'pirate'] as const;
export type TableTheme = (typeof TABLE_THEMES)[number];

export const TABLE_THEME_MANIFEST: Record<Exclude<TableTheme, 'default'>, string> = {
  pirate: '/themes/pirate/theme.json',
};

interface TableThemeStore {
  readonly theme: TableTheme;
  setTheme(theme: TableTheme): void;
}

export const useTableThemeStore = create<TableThemeStore>()(
  persist(
    (set) => ({
      theme: 'default',
      setTheme(theme) {
        set({ theme });
      },
    }),
    { name: 's4k:table-theme' },
  ),
);
